import { jsxs as i, jsx as l } from "react/jsx-runtime";
import o from "clsx";
import e from "./Label.module.css.js";
const x = ({
  text: m,
  description: a,
  required: c,
  underline: s = !1,
  for: n,
  id: t,
  className: p,
  children: r
}) => /* @__PURE__ */ i("label", { htmlFor: n, className: o(e.container, { [e.underline]: s }, p), children: [
  /* @__PURE__ */ i("div", { id: t, className: o(e.labelText, { [e.underline]: s }), children: [
    m,
    c ? (
      // Using empty span with :after styling works best for accessibility, while keeping Jest selectors working as expected.
      // For more info, see discussion in https://github.com/lokalise/lokalise-main/pull/3610
      /* @__PURE__ */ l("span", { className: e.asteriskIcon, role: "img", "aria-label": "Required" })
    ) : null,
    !!a && /* @__PURE__ */ l("p", { className: e.labelDescription, children: a })
  ] }),
  r && /* @__PURE__ */ l("div", { children: r })
] });
export {
  x as Label
};
//# sourceMappingURL=Label.js.map
